###
VueX module for interacting with the Grassdoor cart
###

export state =

	# Store the customers zip and whether they are supported by Grassdoor
	zipIsSupported: null

	# Count of items in the cart
	itemCount: null

	# Array of purchaseable products for user's zip
	purchaseableProducts: []

	# Have we finished loading all of the initial data
	hydrated: false

export mutations =

	# Set the item count
	setItemCount: (state, count) -> state.itemCount = count || 0

	# Set the purchaseable products
	setPurchaseableProducts: (state, products) ->
		state.purchaseableProducts = products

	# Store the customer's zip and whether Grassdoor supports that zip
	setZipSupported: (state, bool) -> state.zipIsSupported = bool

	# Mark has hydrated
	isHydrated: (state) -> state.hydrated = true

	# Open the cart
	open: -> grassdoorCart.showCart()

export getters =

	# Cart is enabled as long as zip is support
	enabled: (state) -> state.zipIsSupported

	# Make a getter for parity with Shopify cart's API
	itemCount: (state) -> state.itemCount

export actions =

	# Determine if the user's zip is supported by Grassdoor
	determineIfZipSupported: ({ rootState, commit }, zip ) ->
		try { data } = await @$grassdoorApi.get '/address/checkServiceByZipcode',
			params: zip_code: zip
		catch e # Ignore errors
		isSupported = data?.success && data?.data?.isAvailable
		commit 'setZipSupported', isSupported
		return isSupported

	# Get products available to the user's zip. These are needed both for checking
	# if it's purchaseable but also for how products get added to the cart.
	fetchPurchaseableProducts: ({ commit }) ->

		# Fetch list of all categories and products that are accessible to the
		# customer's zip.
		try { data } = await @$grassdoorApi.get '/products/listproducts/2'
		catch e then return console.error e

		# Make a unique list of just products
		products = data.data.categories.reduce (products, category) ->
			for product in category.products

				# Add unless this product is already in the master list
				unless products.find (addedProduct) -> addedProduct.slug == product.slug
				then products.push product

			# Return updated list of products
			return products
		, []

		# Store the products
		commit 'setPurchaseableProducts', products

	# Get the count of products in the cart
	fetchCount: ({ commit }) ->
		try commit 'setItemCount', grassdoorCart.getCartCount()
		catch e then return console.error e

	# Add an item to the cart. "id" is a Grassdoor product mappingId
	addItem: ({ state, dispatch }, { id, quantity = 1 }) ->

		# Grassdoor doesn't have a way to explicitly set the quantity, so
		# call increment the necessary amount of times
		timesToIncrement = quantity

		# Lookup the product by id
		product = state.purchaseableProducts.find (product) ->
			product.mappingId == id

		# Add it to the cart if it wasn't already in there
		currentCount = (await grassdoorCart.getProductCount(id)) || 0
		if currentCount == 0
			{ status: success } = await grassdoorCart.addProductToCart product
			throw "Error adding to Grassdoor cart: #{product.slug}" unless success
			timesToIncrement--

		# Grassdoor doesn't have a way to explicitly set the quantity, so
		# call increment the necessary amount of times
		if timesToIncrement > 0
		then for [1..timesToIncrement]
			await grassdoorCart.updateProductCount id, 1

		# Update the cart quantity
		dispatch 'fetchCount'
